import { SENTRY_ERROR_TYPES } from '../../constants';
import React, { ReactNode } from 'react';
import { captureException } from '../../utils';
import { IApiError } from '../../types';

interface ErrorBoundaryProps {
	children: ReactNode;
}

interface ErrorBoundaryState {
	error: Error | null;
}

class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { error: null };
	}

	static getDerivedStateFromError(error: IApiError): ErrorBoundaryState {
		return { error };
	}

	componentDidCatch(error: IApiError, errorInfo: Record<string, unknown>) {
		this.setState({ error });
		captureException(error, {
			extras: errorInfo,
			tags: {
				errorType: SENTRY_ERROR_TYPES.Component,
			},
		});
	}

	render() {
		const { error } = this.state;
		const { children } = this.props;
		if (error) {
			// render fallback UI
			return <></>;
		}
		// when there's not an error, render children untouched
		return children;
	}
}

export default ErrorBoundary;
